/*
 * Échantillons offerts dans le panier flottant.
 *
 * Le serveur (snippets/cart-drawer.liquid) décide quand afficher le sélecteur et quels
 * échantillons proposer (les N produits de la collection choisie ayant le plus de stock).
 * Ce script gère les clics "Choisir" et fait respecter les règles côté navigateur :
 *   - 1 seul échantillon, en quantité 1
 *   - aucun échantillon sans produit payant dans le panier
 *   - échantillon retiré si le montant des produits payants repasse sous le seuil
 * La liste des échantillons se fait aussi défiler à la souris (glisser-déposer).
 * Un échantillon est une ligne de panier portant la propriété cachée _echantillon=true.
 */
(function () {
  if (window.__cartSamplesBound) return;
  window.__cartSamplesBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var dismissed = false;
  var lastSignature = null;
  var timer = null;

  function isSample(item) {
    return !!(item.properties && (item.properties._echantillon === 'true' || item.properties._echantillon === true));
  }

  function config() {
    var el = document.getElementById('cart-samples-config');
    if (!el) return null;
    return {
      threshold: parseInt(el.getAttribute('data-threshold'), 10) || 0,
      signature: el.getAttribute('data-signature') || ''
    };
  }

  // Même assiette que le rendu serveur : lignes payantes, remises panier déduites.
  function paidSubtotal(cart, paidItems) {
    var gross = paidItems.reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
    var cartDiscount = (cart.cart_level_discount_applications || []).reduce(function (sum, d) {
      return sum + (d.total_allocated_amount || 0);
    }, 0);
    return Math.max(0, gross - cartDiscount);
  }

  function sectionIds() {
    try {
      return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
    } catch (e) {
      return [];
    }
  }

  async function render(sections) {
    try {
      await Alpine.store('xCartHelper').reRenderSections(sections);
      Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML, 10) || 0;
    } catch (e) { /* le panier se mettra à jour à la prochaine action */ }
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }

  async function updateLines(updates) {
    var response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionIds() })
    });
    var data = await response.json();
    await render(data.sections);
  }

  async function reconcile() {
    if (busy) return;
    var cfg = config();
    if (!cfg) return;
    var response;
    try { response = await fetch(root + 'cart.js'); } catch (e) { return; }
    var cart = await response.json();
    var items = cart.items || [];
    var samples = items.filter(isSample);
    if (!samples.length) return;

    var paid = items.filter(function (i) { return !isSample(i); });
    var updates = null;

    if (!paid.length || paidSubtotal(cart, paid) < cfg.threshold) {
      updates = {};
      samples.forEach(function (i) { updates[i.key] = 0; });
    } else if (samples.length > 1 || samples.some(function (i) { return i.quantity > 1; })) {
      updates = {};
      samples.forEach(function (i, index) { updates[i.key] = index === 0 ? 1 : 0; });
    }
    if (!updates) return;

    busy = true;
    try { await updateLines(updates); } finally { busy = false; }
  }

  async function addSample(variantId) {
    if (busy || !variantId) return;
    busy = true;
    var button = document.querySelector('[data-sample-pick][data-variant-id="' + variantId + '"]');
    if (button) button.disabled = true;
    try {
      if (window.Alpine && Alpine.store('xCartHelper')) await Alpine.store('xCartHelper').waitForCartUpdate();
      window.updatingCart = true;
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _echantillon: 'true' } }],
          sections: sectionIds()
        })
      });
      var data = await response.json();
      if (data.status) throw new Error(data.description || data.message || 'add failed');
      await render(data.sections);
    } catch (e) {
      if (button) button.disabled = false;
      console.error('[cart-samples]', e);
    } finally {
      window.updatingCart = false;
      busy = false;
    }
  }

  function applyDismissed() {
    var block = document.querySelector('[data-cart-samples]');
    if (block) block.classList.toggle('is-dismissed', dismissed);
  }

  document.addEventListener('click', function (event) {
    var pick = event.target.closest && event.target.closest('[data-sample-pick]');
    if (pick) {
      event.preventDefault();
      addSample(parseInt(pick.getAttribute('data-variant-id'), 10));
      return;
    }
    var close = event.target.closest && event.target.closest('.cart-drawer__samples-close');
    if (close) {
      event.preventDefault();
      dismissed = true;
      applyDismissed();
    }
  });

  // Glisser-déposer à la souris sur la liste d'échantillons (au doigt, le défilement natif suffit).
  var drag = null;
  var suppressClick = false;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var list = event.target.closest && event.target.closest('.cart-drawer__samples-list');
    if (!list) return;
    drag = { list: list, x: event.clientX, left: list.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', function (event) {
    if (!drag) return;
    var dx = event.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.list.classList.add('is-dragging');
    }
    if (drag.moved) {
      drag.list.scrollLeft = drag.left - dx;
      event.preventDefault();
    }
  });

  function endDrag() {
    if (!drag) return;
    if (drag.moved) {
      // le clic qui suit le relâchement ne doit pas choisir l'échantillon
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 300);
    }
    drag.list.classList.remove('is-dragging');
    drag = null;
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('click', function (event) {
    if (!suppressClick) return;
    suppressClick = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  // À chaque rendu du panier : réappliquer la fermeture éventuelle puis vérifier les règles.
  function onDrawerChange() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var cfg = config();
      if (cfg && cfg.signature !== lastSignature) {
        if (lastSignature !== null) dismissed = false;
        lastSignature = cfg.signature;
        reconcile();
      }
      applyDismissed();
    }, 150);
  }

  // On observe toute la page (et non #CartDrawer) : le thème recrée le contenu du panier,
  // un observateur posé sur un nœud précis perdrait la trace des rendus suivants.
  new MutationObserver(onDrawerChange).observe(document.documentElement, { childList: true, subtree: true });
  onDrawerChange();
})();
